import type { TFunction } from 'i18next';
import { ApiServiceError } from '../../services/apiService';

/** The backend's explanation if there is one, otherwise a generic message. */
export function describeError(err: unknown, t: TFunction): string {
  if (err instanceof ApiServiceError && err.detail) return err.detail;
  return t('common:errors.generic');
}

/**
 * Stable keyword ID derived from the English label, e.g. "Alarm management"
 * -> "alarm-management". Mirrors make_keyword_id in search_shared/keywords.py;
 * returns '' if the label has no usable characters.
 */
export function makeKeywordId(label: string, existingIds: Set<string>): string {
  const base = label
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  if (!base) return '';
  let candidate = base;
  for (let suffix = 2; existingIds.has(candidate); suffix++) {
    candidate = `${base}-${suffix}`;
  }
  return candidate;
}

export function formatDateTime(value: string | null | undefined, language: string): string {
  if (!value) return '';
  return new Intl.DateTimeFormat(language, { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value));
}

export function formatShare(share: number | null | undefined): string {
  return share == null ? '' : `${(share * 100).toFixed(share < 0.01 ? 2 : 1)} %`;
}
